import moment from 'moment'
import dateMask from 'app/utils/date/dateMask'

// eslint-disable-next-line import/prefer-default-export
export const isValidFromInPast = (validFrom: string): boolean => {
    if (!validFrom) return false
    const today = moment().startOf('day')
    const validFromDate = moment(validFrom, dateMask).startOf('day')

    return validFromDate.isSameOrBefore(today)
}
